import { render, staticRenderFns } from "./ProductApproval.vue?vue&type=template&id=4ed0c0be&scoped=true&"
import script from "./ProductApproval.vue?vue&type=script&lang=js&"
export * from "./ProductApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed0c0be",
  null
  
)

export default component.exports